export default __webpack_public_path__ + "static/media/grama-esportiva5.d3f294da.jpg";